// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
// import Vant from 'vant';
// import 'vant/lib/index.css';
// Vue.use(Vant);
// import "./public/vue.min.js"
import App from './App'
import router from './router'
import axios from './http/index'
import './public/public.js'
import store from "./store/index.js"

Vue.prototype.$axios = axios

Vue.config.productionTip = false


import vueSwiper from 'vue-awesome-swiper'

import 'swiper/swiper-bundle.css'

import 'vue2-toast/lib/toast.css';
import Toast from 'vue2-toast';
Vue.use(Toast, {
  // wordWrap: true,
  type: 'center',
  duration: 3000,
  wordWrap: true,
  width: '80%'
});

Vue.use(vueSwiper)

import empty from "./components/empty.vue";
Vue.component('empty', empty)

Vue.prototype.copy = function (message, func) {
  var input = document.createElement("input");
  input.value = message;
  document.body.appendChild(input);
  input.select();
  input.setSelectionRange(0, input.value.length);
  document.execCommand("Copy");
  document.body.removeChild(input);
  this.$toast.center("复制成功");
  if (typeof (func) == "function") {
    func()
  }
}


// import VConsole from 'vconsole'
// new VConsole()


Vue.config.ignoredElements = [
]
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  store,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js